export default __webpack_public_path__ + "static/media/mops-kariert.7349e65a.jpg";